{
  "A": {
    "long": "Active",
    "short": "active"
  },
  "BD": {
    "long": "Battery",
    "short": "battery dead"
  },
  "BES": {
    "long": "External power and internal battery are critically low. Device will power down soon",
    "short": "battery needs shutdown"
  },
  "BL": {
    "long": "Low battery",
    "short": "low"
  },
  "BN": {
    "long": "Battery charge is not low",
    "short": "ok"
  },
  "C": {
    "long": "Switch closed",
    "short": "closed"
  },
  "DPL": {
    "long": "Depth low",
    "short": "low"
  },
  "DPN": {
    "long": "Depth normal",
    "short": "normal"
  },
  "DPH": {
    "long": "Depth high",
    "short": "high"
  },
  "DPO": {
    "long": "Depth over",
    "short": "over"
  },
  "DVS": {
    "long": "Device is asleep",
    "short": "asleep"
  },
  "DVSA": {
    "long": "Device sleep aborted",
    "short": "sleep mode aborted"
  },
  "DVSQ": {
    "long": "Device sleeping soon",
    "short": "sleep mode starting"
  },
  "DVSW": {
    "long": "Device woke up",
    "short": "just woke up"
  },
  "FLF": {
    "long": "Flowing",
    "short": "flowing"
  },
  "FLN": {
    "long": "Not flowing",
    "short": "not flowing"
  },
  "FLOV": {
    "long": "Flowing (Over)",
    "short": "flowing over"
  },
  "GDSBL": {
    "long": "Location disabled",
    "short": "disabled"
  },
  "GERR": {
    "long": "GPS chip error",
    "short": "error"
  },
  "GLK": {
    "long": "Decent location accuracy",
    "short": "locked"
  },
  "GOFF": {
    "long": "GPS chip off",
    "short": "off"
  },
  "GST": {
    "long": "Excellent location accuracy",
    "short": "strong lock"
  },
  "GULK": {
    "long": "No location accuracy",
    "short": "unlocked"
  },
  "HHI": {
    "long": "High",
    "short": "high"
  },
  "HNO": {
    "long": "Normal",
    "short": "normal"
  },
  "HLO": {
    "long": "Low",
    "short": "low"
  },
  "I": {
    "long": "Inactive",
    "short": "inactive"
  },
  "MA": {
    "long": "No magnet",
    "short": "no magnet detected"
  },
  "MP": {
    "long": "Magnet detected",
    "short": "detected"
  },
  "NC": {
    "long": "Device not configured",
    "short": "not configured"
  },
  "NONE": {
    "long": "None",
    "short": "None"
  },
  "PCCW": {
    "long": "Pivot moving clockwise",
    "short": "clockwise"
  },
  "PCCCW": {
    "long": "Pivot moving counterclockwise",
    "short": "counterclockwise"
  },
  "PCDRY": {
    "long": "Pump off (dry)",
    "short": "dry"
  },
  "PCEGOFF": {
    "long": "End gun off",
    "short": "end gun off"
  },
  "PCEGON": {
    "long": "End gun on",
    "short": "end gun on"
  },
  "PCRUN": {
    "long": "Pivot running",
    "short": "running"
  },
  "PCSTOP": {
    "long": "Pivot stopped",
    "short": "stopped"
  },
  "PCWET": {
    "long": "Pump on (wet)",
    "short": "wet"
  },
  "NSIG": {
    "long": "Device has no cellular signal",
    "short": "no signal"
  },
  "OFF": {
    "long": "Off",
    "short": "off"
  },
  "ON": {
    "long": "On",
    "short": "on"
  },
  "PHI": {
    "long": "High pressure",
    "short": "high"
  },
  "PLO": {
    "long": "Low pressure",
    "short": "low"
  },
  "POV": {
    "long": "Above threshold",
    "short": "over"
  },
  "RE": {
    "long": "Extending to run start location",
    "short": "extend"
  },
  "RR": {
    "long": "Retracting",
    "short": "retract"
  },
  "RS": {
    "long": "Stopped",
    "short": "stopped"
  },
  "THI": {
    "long": "High",
    "short": "high"
  },
  "TNO": {
    "long": "Normal",
    "short": "normal"
  },
  "TLO": {
    "long": "Low",
    "short": "low"
  },
  "VFDOF": {
    "long": "VFD Off",
    "short": "Off"
  },
  "VFDOV": {
    "long": "Over Max Speed",
    "short": "Over Max"
  },
  "VFDPIDT": {
    "long": "Tracking Setpoint",
    "short": "Tracking"
  },
  "VFDRP": {
    "long": "VFD Ramping",
    "short": "Ramping"
  },
  "VFDST": {
    "long": "VFD On",
    "short": "On"
  },
  "VFDUN": {
    "long": "Under Min Speed",
    "short": "Under Min"
  },
  "WF": {
    "long": "Moving fast",
    "short": "fast"
  },
  "WL": {
    "long": "Moving slowly",
    "short": "slow"
  },
  "WS": {
    "long": "Stopped",
    "short": "stopped"
  },
  "WUNK": {
    "long": "Unknown",
    "short": "Unknown"
  }
}
